export default __webpack_public_path__ + "e4f02a32ade2fcc172a9d3db743fb89e.png";